"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configLogoutRoutes = void 0;
const miragejs_1 = require("miragejs");
const configurations_1 = require("../../../data-manager/configurations");
function configLogoutRoutes(server) {
    server.post((0, configurations_1.getServer)().CUSTOMER_SECURITY + configurations_1.PATH.LOG_OUT, (schema, request) => {
        const isMock401Error = false;
        const isMockCommonError = false;
        if (isMock401Error) {
            return new miragejs_1.Response(401, {}, {});
        }
        else if (isMockCommonError) {
            return new miragejs_1.Response(200, {}, {});
        }
        else {
            // success
            return new miragejs_1.Response(200, {}, {
                lastLoginDate: '2021-12-10T14:47:52.362',
                lastLogoutDate: '2021-12-10T14:48:23.657'
            });
        }
    });
    return server;
}
exports.configLogoutRoutes = configLogoutRoutes;
